module.exports = ".empty-chat {\n  padding: 30px;\n}\n\n.empty-chat > .user-name {\n  display: inline-block;\n  padding: 0.25em;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n  color: #212529;\n}\n\n.empty-chat > .title {\n  margin: 20px 0;\n}\n\n.empty-chat > .navigation {\n  list-style: none;\n  padding: 0;\n}\n\n.empty-chat > .navigation > li {\n  margin-bottom: 20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/chat/empty-chat/empty-chat.component.css
// module id = ./src/app/pages/admin/icontact/chat/empty-chat/empty-chat.component.css
// module chunks = main